import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import getUrlParams from 'toxilibs/url_params.js'
import developmentEnvironment from '../development_environment.js'

globalEventBus.on('world loaded', load)
globalEventBus.on('world reset',  reset)

globalEventBus.on('line correctly interpreted', moveMarkerTo)

globalEventBus.on('wrong way taken', () => showLineMarker(false))


let {hints} = getUrlParams()


let lineMarkerActivated = hints

let $lineMarker         = $('<div id="line_marker">')

let currentIteration    = 0



if (developmentEnvironment) {
    console.log('DEV : m key toggle lineMarker')
    $(window).on('keydown', function (event) {
        if (event.key === 'm') {
            toggleLineMarker()
        }
    })
}


function moveMarkerTo (lineNumber) {
    currentIteration += 1
    let $lineContainer = $('.code .line.number' + lineNumber)

    let left = 0
    let $firstWord = $lineContainer.find('code:first')
    if ($firstWord.hasClass('spaces')) {
        left = $firstWord.width()
    }

    $lineMarker.css('right', ($lineContainer.width() - left) + 'px')

    $lineMarker.text(currentIteration)
    $lineMarker.appendTo($lineContainer)
    if (lineMarkerActivated) {
        showLineMarker()
    }

    if (tries >= 10 && currentIteration === 1 && !helpStatus) {
        showModal()
    }
}


let tries
let fadeDelay = 500
let $modal = $('#modal_want_help')

let helpStatus

function load () {
    tries = 0
    currentIteration = 0
    if (helpStatus === 'wanted') {
        lineMarkerActivated = false
        helpStatus = null
        showLineMarker(lineMarkerActivated)
    }
}

function reset () {
    tries += 1
    currentIteration = 0
}

function showModal () {
    $('.blur_on_modal').addClass('blurry')
    $modal.fadeIn(fadeDelay)
    $modal.find('button.yes').click(() => {
        lineMarkerActivated = true
        helpStatus = 'wanted'
        hideModal()
        showLineMarker()
    })
    $modal.find('button.no').click(() => {
        helpStatus = 'refused'
        hideModal()
    })
}

function hideModal () {
    $('.blur_on_modal').removeClass('blurry')
    $modal.fadeOut(fadeDelay)
}


function toggleLineMarker () {
    lineMarkerActivated = !lineMarkerActivated
    showLineMarker(lineMarkerActivated)
}


function showLineMarker (status = true) {
    if (status) {
        $lineMarker.show()
    } else {
        $lineMarker.hide()
    }

}





